/**
 * User: Joe Forzano
 * Date: October 19th, 2015
 */

'use strict';

const SoaModel = require('bunsen/models/SoaModel.js');

module.exports = SoaModel.extend({

    isAccepted() {
        return this.get('accepted') === 'Y';
    },
    canSnooze() {
        return this.get('snoozeSecs') !== -1;
    }
});




// WEBPACK FOOTER //
// ./~/bunsen/models/identity/Agreement.es.js